import React from 'react'
import styled from 'styled-components'
import { ReactComponent as WhatsAppIcon } from './images/whats_app.svg'
export const ConcactWrap = styled.div`
  z-index: 9;
  position: fixed;
  width: 0.88rem;
  height: 0.88rem;
  right: 0.35rem;
  bottom: 1.26rem;
  border-radius: 0.08rem;
  background: ${p => p.theme.color.secondary};

  a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  svg {
    width: 0.44rem;
    height: 0.44rem;
    path {
      fill: #fff;
    }
  }
`
export const ApplyContainer = styled.div`
  width: 6rem;
  padding: 0 0.2rem 0.4rem;
  h2 {
    text-align: center;
    margin-bottom: 0.4rem;
    font-size: 0.36rem;
  }
  .rc-select-selector {
    height: 0.7rem;
  }
`
export const FormItem = styled.div`
  margin-bottom: 14px;
  input {
    display: block;
  }
`
export const ButtonWrapper = styled.div`
  button {
    width: 100%;
    height: 0.8rem !important;
    display: block;
    margin-top: 0.4rem;
  }
`

const MobileConcact = () => {
  return (
    <>
      <ConcactWrap>
        <a href='https://wa.me/8618926057801'>
          <WhatsAppIcon></WhatsAppIcon>
        </a>
      </ConcactWrap>
    </>
  )
}
export default MobileConcact
